import React from "react"
import { Descriptions, Drawer, Spin, Table, Tag } from "antd"
import { formatDate, formatPoints } from "./format"

const OPERATION_STATUS = {
  pending: { color: "default", label: "Ждёт" },
  sending: { color: "processing", label: "Отправляется" },
  sent: { color: "success", label: "Списано" },
  failed: { color: "error", label: "Ошибка" },
  cancelled: { color: "default", label: "Снято" },
}

// Карточка должника: долг, баланс по дням и операции списания из журнала.
export function DebtUserDrawer({ userId, loadUser, onClose }) {
  const [card, setCard] = React.useState(null)
  const [isLoading, setIsLoading] = React.useState(false)

  React.useEffect(() => {
    if (!userId) return
    setIsLoading(true)
    loadUser(userId)
      .then(setCard)
      .finally(() => setIsLoading(false))
  }, [userId])

  const debt = card?.debt

  return (
    <Drawer open={Boolean(userId)} onClose={onClose} width={720} title={`Должник #${userId ?? ""}`} destroyOnClose>
      {isLoading || !debt ? (
        <Spin />
      ) : (
        <>
          <Descriptions size="small" column={2} bordered>
            <Descriptions.Item label="Телефон">{debt.phone || "—"}</Descriptions.Item>
            <Descriptions.Item label="Почта">{debt.email || "—"}</Descriptions.Item>
            <Descriptions.Item label="Списано за сбой">{formatPoints(debt.written_off_points)}</Descriptions.Item>
            <Descriptions.Item label="Баланс перед списанием">{formatPoints(debt.balance_at_write_off)}</Descriptions.Item>
            <Descriptions.Item label="Долг после списания">{formatPoints(debt.initial_debt)}</Descriptions.Item>
            <Descriptions.Item label="Долг сейчас">{formatPoints(debt.current_debt)}</Descriptions.Item>
            <Descriptions.Item label="Погашено">
              {formatPoints(debt.recovered_points)} ({debt.recovered_percent}%)
            </Descriptions.Item>
            <Descriptions.Item label="Погашен">{formatDate(debt.recovered_at)}</Descriptions.Item>
            <Descriptions.Item label="Списание">{formatDate(debt.written_off_at)}</Descriptions.Item>
            <Descriptions.Item label="Проверен в CRM">{formatDate(debt.last_checked_at)}</Descriptions.Item>
          </Descriptions>

          <h4 style={{ marginTop: 24 }}>Баланс по дням</h4>
          <Table
            size="small"
            rowKey="date"
            pagination={false}
            dataSource={card.snapshots}
            columns={[
              { title: "День", dataIndex: "date" },
              { title: "Баланс", dataIndex: "balance", align: "right", render: formatPoints },
              { title: "Долг", dataIndex: "debt", align: "right", render: formatPoints },
            ]}
          />

          <h4 style={{ marginTop: 24 }}>Операции списания</h4>
          <Table
            size="small"
            rowKey="id"
            pagination={false}
            dataSource={card.operations}
            columns={[
              { title: "Начислено", dataIndex: "accrual_created_at", render: formatDate },
              { title: "Сумма", dataIndex: "points", align: "right", render: formatPoints },
              {
                title: "Статус",
                dataIndex: "status",
                render: (status) => (
                  <Tag color={OPERATION_STATUS[status]?.color}>{OPERATION_STATUS[status]?.label ?? status}</Tag>
                ),
              },
              { title: "Отправлено", dataIndex: "sent_at", render: formatDate },
              { title: "Ошибка", dataIndex: "error", render: (error) => error ?? "—" },
            ]}
          />
        </>
      )}
    </Drawer>
  )
}
